export default {
  system: {
    user: 'Utilisateur',
    level: 'Niveau',
    earnPerTap: 'Gain par tap',
    coinsToLevelUp: 'Pièces pour monter de niveau',
    profitPerHour: 'Profit par heure',
    coming1: "Quelque chose d'intéressant",
    coming2: 'arrive bientôt ici....',
    close: 'Fermer',
    friends: 'Amis',
    continue: 'Continuer',
  },
  settings: {
    chooseNetwork: 'Choisir le réseau',
    chooseLanguage: 'Choisir la langue',
  },
  popup_CheckTask: {
    join: 'Rejoindre',
    check: 'Vérifier',
    taskIsNotCompleted: 'Tâche non terminée',
  },
  popup_levelUp: {
    levelUp: 'Niveau supérieur !',
    multiTap: 'Multi-tap',
    energyLimit: "Limite d'énergie",
  },
  popup_BalanceUp: {
    balanceUp: 'Mise à jour du solde !',
    balanceDiffSinceLast: 'Votre récompense',
  },
  popup_BalanceTip: {
    tip: 'Augmentez votre profit',
    message: 'Appuyez sur le menu Mine pour acheter des améliorations pour votre réseau',
    description: "Gagnez même hors ligne jusqu'à 3 heures",
  },
  popup_Bored: {
    header: "La grenouille s'ennuie !",
    message: 'Jouez avec la grenouille.',
    description: "Si on ne joue pas avec la grenouille pendant 3 heures, le profit s'arrête",
  },
  popup_Hungry: {
    header: 'La grenouille a faim !',
    message: 'Nourrissez la grenouille.',
    description: "Plus vous avez d'amis, plus chaque repas peut rapporter de pièces",
  },
  menu: {
    network: 'Réseau',
    mine: 'Mine',
    earn: 'Gagner',
    food: 'Nourriture',
  },
  tap: {
    bored: 'Ennuyé',
    fun: 'Amusant',
  },
  mineMenu: {
    activities: 'Activités',
    investments: 'Investissements',
    web3: 'WEB3',
    achievements: 'Réalisations',
  },
  leaderboard: {
    from: 'de',
    beTheFirst: 'Soyez le premier !',
  },
  mine: {
    joinOurTG1: 'Rejoignez notre canal Telegram,',
    joinOurTG2: 'pour débloquer !',
    unlock: 'Débloquer',
  },
  friends: {
    inviteFriends: 'Invitez des amis !',
    receiveBonuses: 'Vous et votre ami recevrez des bonus',
    inviteFriend: 'Inviter un ami',
    withTelegramPremium: 'avec Telegram Premium',
    forYouAndYourFriend: 'pour vous et votre ami',
    moreBonuses: 'Plus de bonus',
    listOfYourFriends: 'Liste de vos amis',
    linkCopied: "Le lien d'invitation a été copié dans votre presse-papiers !",
    playWithMe:
      'Rejoignez-moi et jouez pour gagner des jetons via un airdrop !\n' +
      '💰 Attrapez votre cadeau ! +3000 pièces pour les nouveaux venus\n' +
      '🚀 Vous avez Telegram Premium ? Obtenez +5000 pièces !\n',
  },
  earn: {
    moreCoins: 'Gagnez plus de pièces !',
    dailyTasks: 'Tâches quotidiennes',
    dailyReward: 'Récompense quotidienne',
    tasksList: 'Liste des tâches',
    joinOurTG: 'Rejoignez notre canal Telegram',
    followOurX: 'Suivez notre compte X',
    yourAd: 'Votre publicité pourrait être ici',
    connect: "Contactez l'administrateur de notre canal Telegram",
  },
  food: {
    hungry: 'Affamé',
    full: 'Rassasié',
    frogIsFull: 'La grenouille est rassasiée',
    feed: 'Nourrir',
    bonus: 'Bonus',
    satiety: 'Satiété',
    hours: 'heures',
  },
  toast: {
    buyCard: {
      title: 'Succès débloqué !',
      subtitle: 'Il est temps de mener votre empire de grenouilles vers la grandeur 👑',
    },
    feedFrog: {
      title: 'La grenouille est heureuse !',
      subtitle: 'Excellent travail ! Nourrissez votre animal pour garder les sourires 🍽️',
    },
  },
};
